const STATUS_BADGE_CLASSES: Record<string, string> = {
  PENDING: "bg-warning text-dark",
  APPROVED: "bg-success",
  REJECTED: "bg-danger",
};

/** Bootstrap colour classes for a cancellation statement's status badge; unknown statuses are grey. */
export const statementStatusBadgeClass = (status: string): string =>
  STATUS_BADGE_CLASSES[status] ?? "bg-secondary";
